<template>
  <div class="mt-20">
    <StickyBtn />

    <!-- Hero -->
    <Slider :slides="slides" :interval="8000" :ping="true" />

    <!-- Partner list  -->
    <!-- <PartnerList ref="partnersInfo" /> -->

    <!-- Marketing Stats -->
    <GradientPanel :item="marketingData" />

    <div
      class="flex flex-col items-center justify-center w-full lg:px-20 lg:py-32"
    >
      <div
        class="flex flex-wrap lg:flex-nowrap w-full lg:max-w-6xl rounded-none lg:rounded-4xl bg-cw-50 shadow-lg relative overflow-hidden"
      >
        <div class="w-full lg:w-2/3 py-20 px-12 sm:px-16 lg:px-20">
          <div class="flex flex-col items-start relative">
            <h2 class="font-montserrat font-bold text-4xl text-cw-900 mb-2">
              CareerWise is a<br />
              <span class="text-cw-alt font-montserrat">2-sided platform</span>
            </h2>
            <p class="mb-4 text-left text-xl font-bold leading-6">
              with Career Advisors, Students, and Parents on one side and Career
              Pathway providers on the other.
            </p>
            <p class="mb-0 text-left">
              We help both sides find each other and transform how our young
              people discover their best possible lives..
            </p>
          </div>
        </div>
        <img
          :style="[{ right: '-5%' }, { top: '30%' }]"
          class="absolute w-full lg:w-1/3 opacity-10"
          src="/img/cw-marketing/cw-shapes_dots.svg"
          alt="CW alt shapes"
        />
        <div class="hidden lg:flex justify-center items-center w-1/3 relative">
          <img src="/img/cw-marketing/illu-owl.svg" alt="Illustration CW owl" />
        </div>
      </div>
    </div>

    <!-- How it works -->
    <div
      id="intro-box"
      class="py-10 w-full bg-black px-8 lg:px-12 relative overflow-hidden"
    >
      <img
        src="/img/cw-marketing/intro_bg.svg"
        alt="overload images"
        class="filter blur absolute inset-0 h-full w-full object-cover z-10"
        :style="{ animation: 'move 3s ease-in-out infinite' }"
      />
      <div
        class="flex flex-col w-full justify-center items-center text-white py-24 z-20 relative"
      >
        <div class="w-full sm:w-2/5 flex flex-col justify-center">
          <h2
            class="w-full font-montserrat font-black text-center text-5xl px-8 sm:px-0 text-white"
          >
            How it works
          </h2>
        </div>
        <div
          class="gap-8 grid grid-cols-1 mt-8 sm:grid-cols-2 w-full lg:w-3/4 2xl:w-1/2"
        >
          <div
            class="p-3 mx-4 my-4 flex justify-center items-center bg-gradient-to-tr from-pink-600 to-purple-700 rounded-3xl overflow-hidden"
          >
            <div
              class="flex flex-col items-center justify-between gap-6 w-full h-full bg-white rounded-xl p-6"
            >
              <img
                src="/img/cw-marketing/illu-school.svg"
                alt="School icon"
                class="p-0 w-1/5"
              />
              <h3
                class="text-black font-bold font-nunito text-center leading-tight"
              >
                Solution for schools
              </h3>
              <button
                class="m-0 btn btn-trans-black font-nunito w-2/3"
                @click="routeTo('CWForSchools')"
              >
                Learn more
              </button>
            </div>
          </div>
          <div
            class="p-3 mx-4 my-4 flex justify-center items-center bg-gradient-to-tr from-pink-600 to-purple-700 rounded-3xl overflow-hidden"
          >
            <div
              class="flex flex-col items-center justify-between gap-6 w-full h-full bg-white rounded-xl p-6"
            >
              <img
                src="/img/cw-marketing/illu-business.svg"
                alt="Business icon"
                class="p-0 w-1/5"
              />
              <h4
                class="text-black font-bold font-nunito text-center leading-tight"
              >
                Solution for tertiaries, PTEs, and employers
              </h4>
              <button
                class="m-0 btn btn-trans-black font-nunito w-2/3"
                @click="routeTo('CWForBusinesses')"
              >
                Learn more
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA: mobile -->
    <div
      class="flex flex-col items-center justify-center w-full md:py-32 md:px-16"
    >
      <div
        class="flex flex-wrap lg:flex-nowrap w-full lg:max-w-6xl rounded-none md:rounded-4xl bg-cw-700 px-12 pt-20 pb-20 lg:pb-0 sm:p-0 text-white relative overflow-hidden"
      >
        <div class="w-full relative sm:pb-20 lg:pb-24 sm:px-24 sm:pt-24">
          <img
            :style="[{ left: '-30%' }, { bottom: '-30%' }]"
            class="absolute w-full lg:w-10/12 opacity-10 filter brightness-0 invert"
            src="/img/cw-marketing/cw-shapes_dots.svg"
            alt="CW alt shapes"
          />
          <div class="flex flex-col items-start relative">
            <h2 class="font-montserrat font-black text-5xl">
              Try first,<br />Decide later.
            </h2>
            <p class="mb-12 text-left">
              Request a trial and one of our team members will reach out to book
              you in for a 30 minute online demo. We'll set your account up,
              show you how it works, and answer any questions you may have. Then
              you have 2 weeks to use CareerWise and decide if it is right for
              you before you are charged.
            </p>
            <button
              class="m-0 btn btn-cw-alt font-nunito shadow-lg"
              @click="toggleCwRegistration(1)"
            >
              Let's get started
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- School list  -->
    <SchoolList />
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../shared/components/loading.json'
import SchoolList from '../components/SchoolList.vue'
// import PartnerList from '../components/PartnerList.vue'
import CardGroup from '../components/CardGroup.vue'
import StickyBtn from '../components/StickyButton.vue'
import GradientPanel from '../components/GradientPanel.vue'
import Slider from '../components/SliderPanel.vue'

export default {
  components: {
    StickyBtn,
    Slider,
    SchoolList,
    // PartnerList,
    CardGroup,
    GradientPanel,
  },

  mixins: [shared],

  data() {
    return {
      slides: [
        {
          image: '/img/cw-marketing/home_slider_2.png',
          title: 'One Careers Platform.',
          title2: 'Endless Potential.',
          html: 'Transform how <b class="text-2xl">students</b> discover their future, how <b class="text-2xl">schools</b> support their growth, and how <b class="text-2xl">industries</b> find their next breakthrough talent.',
        },
      ],

      services: [
        {
          title: 'Careers Website',
          text: 'Your very own careers website, a place for you to have all your careers information and resources!',
          icon: '/img/cw-marketing/icon-website.png',
        },
        {
          title: 'CareerWise Cloud',
          text: 'The largest amount of careers content...all in once place...for you to access!',
          icon: '/img/cw-marketing/icon-cloud.png',
        },
        {
          title: 'Careers Newsletter',
          text: 'Easily send out the latest career news to students and parents through the built in CareerWise newsletter!',
          icon: '/img/cw-marketing/icon-newsletter.png',
        },
        {
          title: 'Careers Advisor Resources',
          text: "Pre made pages from special 'Guest Authors' and additional resources for career advisors.",
          icon: '/img/cw-marketing/icon-resource.png',
        },
      ],

      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      // partnerData: '',

      marketingData: {
        title: 'CareerWise is the fastest growing Careers platform in NZ',
        text: 'with 52% of all high schools already on board and counting!',
        buttonText: null,
        image: null,
        stats: [
          {
            name: 'Schools',
            numbers: 135,
          },
          {
            name: 'Students',
            numbers: 139000,
          },
          {
            name: 'Career Advisors',
            numbers: 300,
          },
        ],
      },

      isVisible: false,
    }
  },

  created() {
    window.addEventListener('scroll', this.animatePath)
  },

  unmounted() {
    window.removeEventListener('scroll', this.animatePath)
    window.removeEventListener('scroll', this.handleScroll)
  },

  mounted() {
    // this.$set(this, 'partnerData', this.$refs.partnersInfo.partners)
    window.addEventListener('scroll', this.handleScroll)
  },

  methods: {
    // Type of enquiry; 0 === information, 1 === demo, 2 === sign up, 3 === upgrade plan, 4 === other, 5 === Hail
    toggleCwRegistration(type) {
      EventBus.$emit('showModal', 'cw-registration')
      setTimeout(() => {
        EventBus.$emit('new_reason', type)
      }, 50)
    },

    animatePath() {
      // set height of the svg path as constant
      const svg = document.getElementById('svgPath')
      if (svg) {
        const length = svg.getTotalLength()

        // start positioning of svg drawing
        svg.style.strokeDasharray = length

        // hide svg before scrolling starts
        svg.style.strokeDashoffset = length
        const scrollpercent = document.documentElement.scrollTop / length
        const draw = length * scrollpercent

        const calc = length - draw

        let res = calc
        // Once calc reaches 0 our svg animation starts
        // Our svg path is 60% longer then element height because of the curves
        // we accelerate the speed of the animation.
        if (calc < 0) {
          res = calc * 1.7
        }

        // Reverse the drawing when scroll upwards
        svg.style.strokeDashoffset = res
      }
    },

    handleScroll() {
      const introBox = document.querySelector('#intro-box')
      if (introBox) {
        const introHeight = introBox.scrollHeight
        const scrollTop = window.scrollY - 50
        if (scrollTop > introHeight) {
          return (this.isVisible = true)
        } else {
          return (this.isVisible = false)
        }
      }
    },

    routeTo(routeName) {
      this.$router.push({ name: routeName })
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap');

/* Slide-Fade effect : Infor-animation */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  transition-delay: 0.3s;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(12px);
  opacity: 0;
}

.slide-fade-enter-to {
  transition-delay: 0.8s;
}
</style>
